export default __webpack_public_path__ + "static/media/features-2.4fa1bed4.svg";